import * as React from "react";

function SvgAnten(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 841 595"
      {...props}
    >
      <path d="M398 46.6C369.5 49.2 340 57 313 69c-57.4 25.4-106 76.6-129.4 136.2-7.4 18.9-9.8 29.3-10 43.3-.1 13.6.4 16.1 4 20.4 3.1 3.7 7.3 4.1 12.1 1.2 1.7-1.1 7.2-6.6 12.1-12.3 18.6-21.3 47.4-43.8 78.8-61.6 9.6-5.5 27.5-14.2 29-14.2 1.9 0 8.5-6.4 10.4-9.9 1-2.1 2.6-6.8 3.4-10.5 6.2-26.7 26.1-42.5 53.5-42.6 34.4-.1 60.6 31.9 53.6 65.4-3.6 17-13.9 30.8-28.5 37.9-21.6 10.5-40.1 8.9-61.2-5.4-6.7-4.5-12.3-5.2-17.3-2-4.8 2.9-21.4 18.2-28.6 26.2-31.5 35.4-51.4 67.5-65.8 106.1-10.2 27.2-13.7 45.6-12.8 66.8.6 14.7 2.2 22.2 6.8 31.1 6 12 13.2 17.3 23.4 17.3 12.6.1 22.6-8.4 36.9-31 20.2-32.2 47.3-60.4 84.7-88.4 32.4-24.2 73.6-45.9 107.2-56.5 10.6-3.3 11.9-4 16.1-8.5 3.3-3.5 4.9-6.4 6.1-10.6 3.6-13 8.2-21.1 15.8-28.2 13-11.9 33-17.6 48.9-13.8 36.3 8.5 54.3 47.2 37.1 79.8-14.3 27.3-50.8 37.2-76.6 20.8-6.3-4-12.3-5.4-20.7-4.8-5.9.5-8 1.2-15.2 5.3-45.9 26.4-86.4 67.1-111.8 112.3-10.2 18.1-21.9 45.4-25.5 59-1.9 7.7-1.9 18.6.1 24.5 3.5 10.2 15.4 19.1 30.9 23.1 16.5 4.2 45.6 4.5 71.2.7 65.6-9.8 121.1-41.7 162.8-93.6 35.8-44.6 55.1-104.2 53.2-164.5-1.1-36.7-8.6-66.7-24.7-99.5-16.3-33-39.4-62.7-66.5-85.4-33.9-28.3-78.7-47.6-127-54.7-9.9-1.4-42.8-2.6-51.5-1.8z" />
    </svg>
  );
}

export default SvgAnten;
